var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.874,
    height: 11.093,
    viewBox: "0 0 8.874 11.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fill_location",
    "data-name": "fill location",
    transform: "translate(-183.5 -457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location_on_FILL1_wght400_GRAD0_opsz48",
    d: "M12.437,9.408a.97.97,0,1,0-.686-.284A.935.935,0,0,0,12.437,9.408Zm0,5.685A18.438,18.438,0,0,1,9.1,11.564,5.488,5.488,0,0,1,8,8.548,4.289,4.289,0,0,1,9.338,5.234a4.508,4.508,0,0,1,6.2,0,4.289,4.289,0,0,1,1.338,3.314,5.488,5.488,0,0,1-1.1,3.016A18.438,18.438,0,0,1,12.437,15.093Z",
    transform: "translate(175.5 453)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillLocation);
export default __webpack_public_path__ + "static/media/fill_location.3134b10455d91f738590e535bebf91f4.svg";
export { ForwardRef as ReactComponent };